import React from 'react';
import { withRouter } from 'react-router-dom';

import NewInput from 'components/atoms/NewInput';
import Modal from 'components/organisms/NewModal';

const DocumentModal = (props) => {
  const { dataKeyList, modal, getParam, handleSubmit, handleModalClose } =
    props;
  const { open, params = {}, headerTitle, cancelBtnTitle } = modal;

  return (
    <>
      <Modal
        open={open}
        headerTitle={headerTitle}
        handleClose={handleModalClose}
        confirmBtnTitle={cancelBtnTitle}
        confirmOnClick={handleSubmit}
        style={{ minWidth: 620 }}
        useForm
      >
        {(() => {
          const result = [];
          for (let i = 0; i < dataKeyList.length; i++) {
            const { title, name, placeholder } = dataKeyList[i];
            let disabled = modal.type === 'modify' && name === 'uniqNo';
            result.push(
              <tr>
                <th>{title}</th>
                <td>
                  <NewInput
                    type="tableInput"
                    name={name}
                    params={params}
                    value={params[name]}
                    callBack={getParam}
                    disabled={disabled}
                    placeholder={placeholder}
                  />
                </td>
              </tr>
            );
          }
          return result;
        })()}
      </Modal>
    </>
  );
};

export default withRouter(DocumentModal);
